export const FILTERABLE_SELECT_FIELD_PROPS = {
  label: 'Search for and select the type of business you operate',
  name: 'company.business_config.trade_text',
  placeholder: 'Search...',
};
